import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__messages_js_85065717__ from "./messages.js";
function useIframeAppInit({ iframeRef, token, onNavigate }) {
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const iframe = iframeRef.current;
        if (!iframe || !token) return;
        const targetOrigin = new URL(iframe.src).origin;
        const handleMessage = (event)=>{
            console.debug(`[useIframeAppInit] message from ${event.origin}:`, event.data?.type);
            if (event.origin === targetOrigin) {
                if (event.data?.type === __WEBPACK_EXTERNAL_MODULE__messages_js_85065717__.READY_FOR_INIT) {
                    console.debug(`[useIframeAppInit] sending APP_INIT to ${targetOrigin}`);
                    iframe.contentWindow?.postMessage({
                        type: __WEBPACK_EXTERNAL_MODULE__messages_js_85065717__.APP_INIT,
                        payload: {
                            token
                        }
                    }, targetOrigin);
                } else if (event.data?.type === __WEBPACK_EXTERNAL_MODULE__messages_js_85065717__.NAVIGATE && onNavigate) {
                    const relativePath = event.data?.payload?.relativePath;
                    if ('string' == typeof relativePath && relativePath.startsWith('/')) {
                        console.debug(`[useIframeAppInit] navigating to ${relativePath}`);
                        onNavigate(relativePath);
                    }
                }
            }
        };
        window.addEventListener('message', handleMessage);
        console.debug('[useIframeAppInit] registered message listener');
        return ()=>{
            window.removeEventListener('message', handleMessage);
            console.debug('[useIframeAppInit] cleaned up listener');
        };
    }, [
        iframeRef,
        token
    ]);
}
export { useIframeAppInit };

//# sourceMappingURL=useIframeAppInit.js.map